import { MINUTE } from 'lib/durations';

export const DEFAULT_TIME_INTERVAL = 5 * MINUTE;
